module.exports = __webpack_public_path__ + "static/media/sub-strategy-exposure.eb91952d.png";